module.exports = __webpack_public_path__ + "static/media/332x468.916c6331.jpg";